module.exports = __webpack_public_path__ + "static/img/20013 (5).ec2d988.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20013 (5).webp
// module id = Oo18
// module chunks = 14